import React, { useContext} from 'react';

function GrayInfoBox(props) {
    return (
        <div className="container u-mtop50 u-mbottom20">
            <div className="row">
                <div className="col-xs-12">
                    <div className="u-grayBackground u-padding30 text-center">
                        <div className="row">
                            <div className="col-md-8 col-md-push-2">
                                {props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}

export default GrayInfoBox;